import axios from 'axios'

const apiMeterClient = axios.create({
    baseURL: process.env.VUE_APP_BASE_URL,
    headers:{
        "Content-Type": "application/json",
        "auth-api": process.env.VUE_APP_TOKEN_API
    }
})

const responseInterceptor = response => {
    const OK_CODE = 200
    if (response.status == OK_CODE) return response.data
    else return Promise.reject(response)
}

apiMeterClient.interceptors.response.use(responseInterceptor)

export default apiMeterClient
